import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    count: 0,
    // AI 聊天相关状态
    aiChatEnabled: false, // AI 聊天是否可用
    aiInterpretCompleted: false, // AI 解读是否完成
    packageNo: "", // 当前报告编号
    openAiChat:false,
    openInterpret:false

  },
  mutations: {
    // 设置 AI 解读完成状态
    SetAiChatEnabled(state, payload) {
      // state.aiInterpretCompleted = payload.completed;
      // state.currentPackageNo = payload.packageNo || "";
      // 只有解读完成后才允许使用聊天
      state.aiChatEnabled = payload.aiChatEnabled;
    },
    // 重置 AI 状态（切换报告时使用）
    RESET_AI_STATE(state) {
      state.aiChatEnabled = false;
      state.aiInterpretCompleted = false;
      state.packageNo = "";
    },
    // ai解读完毕
    SetPackageNo(state,payload){
      state.packageNo = payload.packageNo;

    },
    // ai解读音频
    SetOpenAiChat(state,payload){
      state.openAiChat = payload.openAiChat;

    },
    SetOpenInterpret(state,payload){
      state.openInterpret = payload.openInterpret;

    },
    
  },
  getters: {
    // 获取 AI 聊天是否可用
    isAIChatEnabled: (state) => state.aiChatEnabled,
    // 获取当前报告编号
    getPackageNo: (state) => state.packageNo,
    // 获取 AI 解读是否完成
    isAIInterpretCompleted: (state) => state.aiInterpretCompleted,
    // 获取ai助手是否打开
    GetOpenAiChat: (state) => state.openAiChat,
    GetOpenInterpret: (state) => state.openInterpret,
  },
});
